import React, { FC } from 'react';
import TreeItem from '@material-ui/lab/TreeItem';
import { withStyles } from '@material-ui/core/styles';
import { TreeItemProps } from '@material-ui/lab/TreeItem/TreeItem';
import CircularProgress from '@material-ui/core/CircularProgress';

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${theme.palette.text.disabled}`,
  },
}))((props: TreeItemProps) => <TreeItem {...props} />);

interface LoadingTreeItemProps extends TreeItemProps {
  isLoading: boolean;
  label: React.ReactNode;
}

export const LoadingTreeItem: FC<LoadingTreeItemProps> = (props) => {
  const { isLoading, label, ...other } = props;
  return (
    <StyledTreeItem
      {...other}
      label={
        isLoading ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CircularProgress size={16} style={{ marginRight: 8 }} />
            <span>Loading...</span>
          </div>
        ) : (
          label
        )
      }
    />
  );
};
